<template>
  <div class="fullHeigthPage">
    <PageHeader :title="title" :items="items" />
           <!-- ACOMPANHAMENTO -->

    <div>
      <b-card no-body>
        <b-card-body>
          <b-card-title>
            <h5 class="card-title">Consultar</h5>
          </b-card-title>

          <div class="row">
            <b-form-group
              label="Período"
              invalid-feedback="campo obrigatório"
              class="col-md-3"
              :state="state('referencia')"
            >
              <date-picker
                v-model="dados.referencia"
                range
                append-to-body
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                placeholder="Intervalo"
              ></date-picker>
            </b-form-group>
            <b-form-group
              label="Contrato Serviço"
              invalid-feedback="campo obrigatório"
              class="col-md-2"
              :state="state('contrato')"
            >
              <multiselect
                v-model="dados.contrato"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionContrato"
                label="nome"
                :allow-empty="false"
                @input="inputContrato"
              />
            </b-form-group>
            <b-form-group
              label="Projeto"
              invalid-feedback="campo obrigatório"
              class="col-md-3"
              :state="state('projeto')"
            >
              <multiselect
                v-model="dados.projeto"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionProjeto"
                label="nome"
                :allow-empty="false"
                @input="inputProjeto"
              />
            </b-form-group>
            <b-form-group
              label="Cooperado"
              invalid-feedback="campo obrigatório"
              class="col-md-4"
              :state="state('cooperado')"
            >
              <multiselect
                v-model="dados.cooperado"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionCooperado"
                label="nome"
                :allow-empty="true"
              />
            </b-form-group>
          </div>
          <div class="row">
            <div class="d-flex justify-content-end px-1">
              <div class="me-2 align-self-center mt-1">
                <b-button variant="primary" @click="filtrar()" class="m-1">
                  <i class="mdi mdi-filter-outline font-size-16 align-middle me-2"></i>
                  Filtrar
                </b-button>
              </div>
              <div div class="me-2 align-self-center mt-1">
                <b-button @click="limparFormulario()">
                  <i class="mdi mdi-broom font-size-16
                      align-middle me-2"></i>
                  Limpar
                </b-button>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>

    <div class="row">
      <!-- COOPERADO -->
      <div class="col-md-4" v-if="viewCoop">
        <b-card class="heightCard" no-body>
          <b-card-body >
            <div class="row">
              <div class="col-md-3">
                <img
                  :src="dadosCoop.fotoCoop ? dadosCoop.fotoCoop : require('@/assets/images/user.png')"
                  alt
                  class="avatar-lg rounded-circle img-thumbnail"
                />
              </div>
              <div class="col-md-9">
                  <h5 class="font-size-15">{{dadosCoop.coopNome}}</h5>
                  <h6 class="font-size-13">{{dadosCoop.coopProfissao}}</h6>
                  <p class="text-muted mb-0 ">{{dadosCoop.coopCargo}}</p>
              </div>
            </div>


            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Contrato</th>
                    <td>{{dadosCoop.contrato}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Projeto</th>
                    <td>{{dadosCoop.projeto}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sede</th>
                    <td>{{dadosCoop.sede}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Período</th>
                    <td>{{dadosCoop.periodo}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Idade</th>
                    <td>{{dadosCoop.idade}} Anos</td>
                  </tr>
                  <tr>
                    <th scope="row" class="w-25">Tempo CNH</th>
                    <td>{{dadosCoop.tempoCnh}}  Anos</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <!-- VEÍCULOS -->
      <div class="col-md-4" v-if="viewVeiculos">
        <b-card class="heightCard" no-body>
          <b-card-body >
            <div class="row">
              <div class="d-flex align-items-center justify-content-between">
                <div class="card-title">Veículos</div>
                <span class="font-size-16 badge"
                      :class="{
                        'bg-success':dadosVeiculo.st_veiculo_condutor === 'ATIVO',
                        'bg-danger':dadosVeiculo.st_veiculo_condutor === 'INATIVO'
                      }">
                  {{dadosVeiculo.st_veiculo_condutor}}</span>
              </div>
            </div>

            <div class="row mt-5">
              <div class="d-flex justify-content-between text-center">
                <b-button :disabled="listaVeiculo[indexVeiculo - 1] ? false : true"
                          @click="trocarVeiculo('anterior')" 
                          variant="primary" 
                          class="py-0 align-self-center">                   
                  <i class="mdi mdi-arrow-left-bold font-size-20"></i> 
                </b-button>
                <div>
                  <div class="m-2 mx-auto avatar-lg">
                    <img class="img-fluid rounded-circle opacity-50"
                         :src="require('@/assets/images/logo-marcas/'+dadosVeiculo.cd_marca+'.svg')"/>
                  </div>
                  <h5 class="font-bold">{{dadosVeiculo.nm_versao}} {{dadosVeiculo.nr_ano_veiculo}}</h5>
                  <h6>{{dadosVeiculo.nm_categoria}}</h6>
                  <h6>{{$tools.converteData(dadosVeiculo.dt_inicio_veiculo)}} à {{$tools.converteData(dadosVeiculo.dt_final_veiculo)}}</h6>
                </div>
                <b-button :disabled="listaVeiculo[indexVeiculo + 1] ? false : true"
                          @click="trocarVeiculo('proximo')" 
                          variant="primary" 
                          class="py-0 align-self-center">                   
                  <i class="mdi mdi-arrow-right-bold font-size-20"></i> 
                </b-button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6 text-center">
                
                <p class="mb-2 mt-4">PLACA</p>
                <div class="ms-3 me-3 bg-primary rounded-top">
                  <h6 class="font-size-10 m-0 text-white">BRASIL</h6>
                </div>
                <h4 class="ms-3 me-3 p-1 bg-light order border-secondary 
                           border-top-0 bg-gradient rounded-bottom">
                  {{dadosVeiculo.nr_placa}}
                </h4>
              </div>
              <div class="col-6 text-center">
                <p class="mb-2 mt-4">ODÔMETRO</p>
                <h4 class="p-3">{{parseInt(dadosVeiculo.qt_km_odometro).toLocaleString('pt-BR')}}KM</h4>
              </div>
            </div>
          </b-card-body>  
        </b-card>
      </div>
      <!-- -->
      <!-- NECESSÁRIAS  -->
      <div class="col-md-4" v-if="viewAcoes">
        <b-card class="heightCard" no-body>
          <b-card-body>
            <h4 class="card-title mb-4">Resumo de Ocorrências</h4>
            <div class="row mt-5">

              <div class="col-md-6">

                <div class="talkbubble-top" v-if="tooltipResumo.ex">
                  Excesso de Velocidade<br>
                  Critérios:<br>
                  Entre 120 e 129 KM/H – De 00:00:00 a 23:59:59
                </div>

                <div @mouseover="tooltipResumo.ex = true" 
                     @mouseout="tooltipResumo.ex = false" 
                     class="card bg-card-waning shadow-none border">
                  <div class="card-body p-3">
                    <h1 class="text-center">{{dadosOcorrencia.excesso}}</h1>
                  </div>
                  <h6 class="text-center ">Excesso de Velocidade</h6>
                </div>

              </div>
              <div class="col-md-6">
                <div class="talkbubble-top" v-if="tooltipResumo.fh">
                  Fora do Horário<br>
                  Critérios:<br>
                  Domingo – De 00:00:00 a 23:59:59<br>
                  Segunda-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                  Terça-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                  Quarta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                  Quinta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                  Sexta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                  Sábado - Vespertino/Noturno– De 14:00:00 a 23:59:59<br>
                </div>

                <div @mouseover="tooltipResumo.fh = true" 
                     @mouseout="tooltipResumo.fh = false"  
                     class="card bg-card-secondary shadow-none border">
                  <div class="card-body p-3">
                    <h1 class="text-center">{{dadosOcorrencia.foraHorario}}</h1>
                  </div>
                  <h6 class="text-center">Uso Fora do Horário</h6>
                </div>
              </div>
              <div class="col-md-6">
                <div class="talkbubble-top" v-if="tooltipResumo.ma">
                  Uso na Madrugada<br>
                  Critérios:<br>
                  Segunda-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                  Terça-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                  Quarta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                  Quinta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                  Sexta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                  Sábado – Madrugada – De 00:00:00 a 04:59:59<br>
                </div>

                <div @mouseover="tooltipResumo.ma = true" 
                     @mouseout="tooltipResumo.ma = false" 
                     class="card bg-card-primary shadow-none border">
                  <div class="card-body p-3">
                    <h1 class="text-center">{{dadosOcorrencia.madrugada}}</h1>
                  </div>
                  <h6 class="text-center">Uso na Madrugada</h6>
                </div>
              </div>
              <div class="col-md-6">
                <div class="talkbubble-top" v-if="tooltipResumo.ri">
                  Conducao de Risco<br>
                  Critérios:<br>
                  Acima de 130 KM/H – De 00:00:00 a 23:59:59
                </div>

                <div @mouseover="tooltipResumo.ri = true" 
                     @mouseout="tooltipResumo.ri = false" 
                     class="card bg-card-danger shadow-none border">
                  <div class="card-body p-3">
                    <h1 class="text-center">{{dadosOcorrencia.risco}}</h1>
                  </div>
                  <h6 class="text-center">Condução de Risco</h6>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <!-- -->
    </div>

    <div class="row">
      <div class="col-md-4">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-card-title>
              <h5 class="card-title">Mapa</h5>
            </b-card-title>
            <div class="row" v-if="diaMapa">
              <div class="div-clickable col-md-6 mt-4">
                <div class="bg-info bg-soft text-center p-3">
                  <h5 class="font-size-14 mb-0">Data</h5>
                </div>
                <div class="text-center p-1 border">
                  <h4>{{diaMapa}}</h4>
                </div>
              </div>
              <div class="div-clickable col-md-6 mt-4">
                <div class="bg-info bg-soft text-center p-3">
                  <h5 class="font-size-14 mb-0">Trajeto/dia (KM)</h5>
                </div>
                <div class="text-center p-1 border">
                  <h4>{{(kmDiario / 1000).toFixed(1)}}</h4>
                </div>
              </div>
            </div>
            <div id="map" style="height: 600px"></div>
   
          </b-card-body>
        </b-card>
      </div>

      <div class="col-md-8">
        <div class="d-flex justify-content-center" v-if="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
        <b-card class="table-responsive" v-if="viewTabela">
          <b-table
            responsive="sm"
            :items="telemetriaDiaria"
            :fields="campos"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template #head(excesso)="scope">
                <div class="talkbubble-bottom" v-if="tooltipTable.ex">
                  Excesso de Velocidade<br>
                  Critérios:<br>
                  Entre 120 e 129 KM/H – De 00:00:00 a 23:59:59
                </div>
                <span class="badge badge-pill font-size-12 badge-soft-warning"
                      @mouseover="tooltipTable.ex = true" 
                      @mouseout="tooltipTable.ex = false">
                  {{ scope.label }}
                </span>
            </template>
            <template #head(foraHorario)="scope">
              <div class="talkbubble-bottom" v-if="tooltipTable.fh">
                Fora do Horário<br>
                Critérios:<br>
                Domingo – De 00:00:00 a 23:59:59<br>
                Segunda-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                Terça-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                Quarta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                Quinta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                Sexta-Feira – Noturno – De 21:00:00 a 23:59:59<br>
                Sábado - Vespertino/Noturno– De 14:00:00 a 23:59:59<br>
              </div>
              <span class="badge badge-pill font-size-12 badge-soft-secondary" 
                    @mouseover="tooltipTable.fh = true" 
                    @mouseout="tooltipTable.fh = false">
                {{ scope.label }}
              </span>
            </template>
            <template #head(madrugada)="scope">
              <div class="talkbubble-bottom" v-if="tooltipTable.ma">
                Uso na Madrugada<br>
                Critérios:<br>
                Segunda-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                Terça-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                Quarta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                Quinta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                Sexta-Feira – Madrugada – De 00:00:00 a 04:59:59<br>
                Sábado – Madrugada – De 00:00:00 a 04:59:59<br>
              </div>
              <span class="badge badge-pill font-size-12 badge-soft-primary" 
                    @mouseover="tooltipTable.ma = true" 
                    @mouseout="tooltipTable.ma = false">
                {{ scope.label }}
              </span>
            </template>
            <template #head(risco)="scope">
              <div class="talkbubble-bottom" v-if="tooltipTable.ri">
                Conducao de Risco<br>
                Critérios:<br>
                Acima de 130 KM/H – De 00:00:00 a 23:59:59
              </div>
              <span class="badge badge-pill font-size-12 badge-soft-danger"
                    @mouseover="tooltipTable.ri = true" 
                    @mouseout="tooltipTable.ri = false">
                {{ scope.label }}
              </span>
            </template>
            <template #head(informativo)="scope">
              <span class="badge bg-light text-dark font-size-12" 
                    data-tooltip="Informativo" 
                    data-tooltip-location="left">
                {{ scope.label }}
              </span>
            </template>
            <template #cell(mapa)="data">
              <b-button variant="primary"
                        @click="montarMapaDirecoes(data.item)">
                <i class="mdi mdi-send"></i>
              </b-button>
            </template>
            <template #cell(dt_gps)="data">
              {{data.item.data}} - {{$tools.diaSemanaAbrev(data.value.getDay())}}
            </template>

          </b-table>
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </b-card>
    
      </div>
    </div>

  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      tooltipResumo:{
        ex:false,
        fh:false,
        ma:false,
        ri:false
      },
      tooltipTable:{
        ex:false,
        fh:false,
        ma:false,
        ri:false
      },
      title: "Acompanhamento | Telemetria de Veículos",
      items: [
        {
          text: "Telemetria",
        },
        {
          text: "Acompanhamento"
        }
      ],
      viewVeiculos: false,
      viewTabela: false,
      viewCoop:false,
      viewAcoes:false,
      map: {},
      heatmap: null,
      google: {},
      submit: false,
      loading: false,
      filtro: [],
      campos: [
        {
          key: "dt_gps",
          label: "Data",
        },
        {
          key: "placa",
          label: "Placa",
        },
        {
          key: "excesso",
          label: "EV",
        },
        {
          key: "foraHorario",
          label: "FH",
        },
        {
          key: "madrugada",
          label: "MA",
        },
        {
          key: "risco",
          label: "CR",
        },
        {
          key: "informativo",
          label: "IN",
        },       
        {
          key: "mapa",
          label: "Mapa"
        }
      ],
      telemetriaDiaria: [],
      acao:"",
      dados: {
        contrato: null,
        matriz: null,
        projeto: null,
        cooperado: null,
        referencia: null,
      },
      dadosCoop:{
        coopNome: "",
        coopCargo: "",
        coopDescCargo: "",
        contrato: "",
        projeto: "",
        sede: "",
        periodo: "",
        fotoCoop: "",
        idade:0,
        tempoCnh:0
      },
      dadosOcorrencia:{           
        excesso:0,
        foraHorario:0,
        madrugada:0,
        risco:0
      },
      dadosVeiculo:{},
      listaVeiculo:[],
      indexVeiculo: 0,
      optionContrato: [],
      optionProjeto: [],
      optionCooperado: [],
      mapsAux: "",
      rows: 0,
      dadosGps:[],
      dashboard: {},
      mapaCalendario:"",
      defaultCalendario:false,
      currentPage: 1,
      perPage: 10,
      directionsAux:[],
      markerOcorrencias: [],
      diaMapa:"",
      kmDiario: 0,
      markerSede:null
    };
  },

  validations: {
    dados: {
      referencia: {
        required,
      },
      contrato: {
        required,
      },
      projeto: {
        required,
      },
      cooperado:{
        required,
      }
    },
  },

  created() {
    this.montarMapa();
    this.$store
      .dispatch("filtroTomador", this.$store.state.filtroTomador)
      .then((response) => {
        this.optionContrato = this.$tools.filtroTomador.selectContratos(response)
        if(this.$store.state.filtroTelemetria){
          var filtro = this.$store.state.filtroTelemetria;
          this.dados.referencia = [filtro.referenciaInicio, filtro.referenciaFim];
          this.dados.contrato = filtro.contrato;
          this.dados.projeto = filtro.projeto;
          this.dados.cooperado = filtro.cooperado;
          this.$store.commit('FILTRO_TELEMETRIA', null);
          this.inputContrato(false);
          this.inputProjeto(false);
           this.filtrar();
        }
      })
      
    window.calcularKmWin = (el) => {
      this.calcularKm(el);
    };
      
  },

  async mounted() {
    try {
      this.google = await this.$gmaps();
      this.map = new this.google.maps.Map(document.getElementById("map"), {
        center: { lat: -23.469806037053726, lng: -51.81222191718324 },
        zoom: 8,
      });    
    } catch (error) {
      console.error(error);
    }
  },

  methods: {
    async montarMapa(){
      try {
        this.google = await this.$gmaps();
        this.map = new this.google.maps.Map(document.getElementById("map"), {
          center: { lat: -23.469806037053726, lng: -51.81222191718324 },
          zoom: 8,
        });
      } catch (error) {
        console.error(error);
      } 
    },
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },
    inputContrato(param = true){
      if(param){
        this.optionProjeto = [];
        this.optionCooperado = [];
        this.dados.projeto = null;
        this.dados.cooperado = null;
        this.dados.matriz = this.dados.contrato.matriz;
      }
      this.optionProjeto = this.$tools.filtroTomador.selectProjetos(this.$store.state.filtroTomador, 
                                                                    this.dados.contrato.numero);
    },
    inputProjeto(param = true){  
      if(param){
        this.optionCooperado = [];
        this.dados.cooperado = null;
      }  
      this.optionCooperado = this.$tools.filtroTomador.selectCooperados(this.$store.state.filtroTomador, 
                                                                        this.dados.projeto.numero);
    },
    filtrar() {
      this.montarMapa();
      this.submit = true;
      this.$v.$touch();
      if(this.$v.$invalid) {
        return
      }
      this.limparMapa();
      this.viewVeiculos = false;
      this.viewTabela = false;
      this.viewAcoes = false;
      this.viewCoop = false;
      this.loading = true;
      this.$http.post("api/telemetria", {
          referenciaInicio: this.dados.referencia[0],
          referenciaFim: this.dados.referencia[1],
          cooperado: this.dados.cooperado.numero,
          cd_projeto: this.dados.projeto.numero,
        })
        .then((response) => {
          this.dadosGps = response.data;
          if(this.dadosGps.length > 0){
            this.filtrarVeiculo();
            this.criarInformacoesDiaria();
            this.atribuiInfoCoop(this.dadosGps[0]);
            this.marcarSede();
            this.$tools.fecharMenu();
          }else{
            alert("Nenhuma informação encontrada com esses parametros");
            this.loading = false;
          }
        }).catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    filtrarVeiculo() {
      this.listaVeiculo = [];
      this.dadosVeiculo = {};
      this.indexVeiculo = 0;
      this.$http.post("api/telemetria/relatorioVeicular", {
          sq_contrato: this.dados.contrato.numero,
          cd_matriz: this.dados.contrato.matriz,
          cd_projeto: this.dados.projeto.numero,
          cd_cooperado: this.dados.cooperado.numero,
          referenciaInicio: this.dados.referencia[0],
          referenciaFim: this.dados.referencia[1],
        })
        .then((response) => {
          this.listaVeiculo = response.data;
          this.dadosVeiculo = this.listaVeiculo[this.indexVeiculo];
          this.viewTabela = true;
          this.viewAcoes = true;
          this.viewCoop = true;
          this.viewVeiculos = true;
          this.loading = false;
        });
    },
    criarInformacoesDiaria() {
      var dataGps = [];
      this.telemetriaDiaria = [];
      var indexLocation = 0;
      var index = 0;
      this.dadosOcorrencia = {           
        excesso:0,
        foraHorario:0,
        madrugada:0,
        risco:0
      };
      this.mapaCalendario = new Date(this.dadosGps[0].dt_gps);
      this.dadosGps.forEach((el) => {
        if(!dataGps.includes(el.data)){
          index = dataGps.push(el.data);
          index--;

          this.telemetriaDiaria[index] = {
            data:el.data,
            dt_gps:new Date(el.dt_gps),
            excesso:0,
            foraHorario:0,
            madrugada:0,
            risco:0,
            informativo:0,
            placa:el.nr_placa,
            dados:[],
            _cellVariants:{}
          }

          indexLocation = this.telemetriaDiaria[index].dados.push(el);
          indexLocation--;

          this.separarOcorrencias(index, el.tp_posicao, indexLocation);
        }else{
          indexLocation = this.telemetriaDiaria[dataGps.length - 1].dados.push(el);
          indexLocation--;
          this.separarOcorrencias(dataGps.length - 1, el.tp_posicao, indexLocation);
        }
      });
      this.rows = dataGps.length;
      this.telemetriaDiaria.forEach((el) => {
        this.dadosOcorrencia.excesso += el.excesso;
        this.dadosOcorrencia.foraHorario += el.foraHorario;
        this.dadosOcorrencia.madrugada += el.madrugada;
        this.dadosOcorrencia.risco += el.risco;
      });
    },
    separarOcorrencias(index, posicao, indexLocation){
      switch (posicao) {
        case "E":
          this.telemetriaDiaria[index].excesso++;
          this.telemetriaDiaria[index].dados[indexLocation].icon = this.$iconOcorrencia+"excesso.png";
          this.telemetriaDiaria[index]._cellVariants.excesso = 'warning';
          break;
        case "F":
          this.telemetriaDiaria[index].foraHorario++;
          this.telemetriaDiaria[index].dados[indexLocation].icon = this.$iconOcorrencia+"foraHorario.png";
          this.telemetriaDiaria[index]._cellVariants.foraHorario = 'secondary';
          break;
        case "M":
          this.telemetriaDiaria[index].madrugada++;
          this.telemetriaDiaria[index].dados[indexLocation].icon = this.$iconOcorrencia+"madrugada.png";
          this.telemetriaDiaria[index]._cellVariants.madrugada = 'primary';
          break;
        case "R":
          this.telemetriaDiaria[index].risco++;
          this.telemetriaDiaria[index].dados[indexLocation].icon = this.$iconOcorrencia+"risco.png";
          this.telemetriaDiaria[index]._cellVariants.risco = 'danger';
          break;
        default:
          this.telemetriaDiaria[index].informativo++;
          this.telemetriaDiaria[index].dados[indexLocation].icon = this.$iconOcorrencia+"informativo.png";
          break;
      }
    },
    trocarVeiculo(param){
      if(param == "proximo"){
        this.indexVeiculo++;
        this.dadosVeiculo = this.listaVeiculo[this.indexVeiculo];
      }else{
        this.indexVeiculo--;
        this.dadosVeiculo = this.listaVeiculo[this.indexVeiculo];
      }
    },
    montarMapaDirecoes(param){
      this.limparMapa();
      this.diaMapa = param.data;
      this.kmDiario = 0;
      var arrayWayPoints = [];
      var matrizWayPoint = [];
      var i = 1;
      var arrayLocation = [];
      arrayLocation.push(param.dados[0]);
      arrayLocation.push(param.dados[param.dados.length - 1]);
      param.dados.forEach((el, key, list) => {
        if(list[key - 1]){
          if(el.ds_localizacao != list[key - 1].ds_localizacao || el.ds_localizacao == null){
            arrayLocation.push(el);
          }
        }
      });

      arrayLocation.forEach((el) => {
        if(i % 24 == 0 || i == arrayLocation.length){
          matrizWayPoint.push(arrayWayPoints);
          arrayWayPoints = [];
          arrayWayPoints.push({location: {lat: parseFloat(el.nr_latitude),
                                          lng: parseFloat(el.nr_longitude)}});
        }else{
          arrayWayPoints.push({location: {lat: parseFloat(el.nr_latitude),
                                          lng: parseFloat(el.nr_longitude)}});
        }
        i++;
      });

      matrizWayPoint.forEach((el) => {
        this.directionsAux.push(this.marcarDirecao(el));
      })

      this.adicionarMarcadores(param.dados);
    },
    marcarDirecao(param){
      var originAux = param[0].location;
      var destinationAux =  param[param.length - 1].location;

      var directionsService = new this.google.maps.DirectionsService();
      var directionsRenderer = new this.google.maps.DirectionsRenderer({
        preserveViewport: false,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: 'green',
          strokeOpacity: 0.5,
          strokeWeight: 7
        },
      });
      directionsRenderer.setMap(this.map);

      var request = {
          origin: originAux,
          destination: destinationAux,
          waypoints: param, 
          travelMode: 'DRIVING'
      };

      directionsService.route(request, function(result, status) {
        if (status == 'OK') {
          directionsRenderer.setDirections(result);
          window.calcularKmWin(result);
        }
      });

      return directionsRenderer;
    },
    adicionarMarcadores(param){
      var icon = {};
      param.forEach((el,key) => {
        if(key === 0){ //Define icone de destino
          icon = {
            url: this.$iconOcorrencia+"origem.png", 
            scaledSize: new this.google.maps.Size(30, 30), 
          };
        }else if(key === param.length - 1){ //Define icone de origem
          icon = {
            url: this.$iconOcorrencia+"dest.png", 
            scaledSize: new this.google.maps.Size(30, 30), 
          };
        }else{
          icon = el.icon;
        }
        this.markerOcorrencias.push({
          marker: new this.google.maps.Marker({
            map:this.map,
            position: {lat: parseFloat(el.nr_latitude),
                       lng: parseFloat(el.nr_longitude)},
            icon:icon
          }), 
          info: el
        });
      })

      var popup = "";
      this.markerOcorrencias.forEach((el) => {
        popup = "Data: "+el.info.data+" "+el.info.hora
                +" "+ this.$tools.diaSemanaAbrev(new Date(el.info.dt_gps).getDay()); //Hora 
        popup += el.info.nr_placa ? "<br>Placa: "+el.info.nr_placa : ""; //Placa
        popup += el.info.veiculo ? "<br>Veiculo: "+el.info.veiculo : ""; //Veiculo
        popup += el.info.rastreador ? "<br>Rastreador: "+el.info.rastreador : ""; //Rastreador
        popup += "<br>Ocorrência: "+this.siglaOcorrencia(el.info.tp_posicao); //Ocorrência
        popup += el.info.nr_velocidade ? "<br>Velocidade: "+el.info.nr_velocidade+" Km/H" : ""; //Velocidade
        popup += el.info.ds_localizacao ? "<br>Localidade: "+el.info.ds_localizacao : ""; //Descricao
        popup += "<br>Cidade-UF: "+el.info.ge_regiao.nm_regiao+" - "+el.info.ge_regiao.ds_uf; //Regiao
        var infowindow = new this.google.maps.InfoWindow({
          content: popup
        });
        el.marker.addListener("click", () => {
          infowindow.open({
            anchor: el.marker,
            map:this.map,
            shouldFocus: false,
          });
        });
      });
    },
    marcarSede(){
      if(this.markerSede){
        this.markerSede.setMap(null);
      }
      this.markerSede = new this.google.maps.Marker({
                          map:this.map,
                          position: {lat: parseFloat(this.dadosGps[0].latitude_coop),
                                    lng: parseFloat(this.dadosGps[0].longitude_coop)},
                          icon:{url:this.$iconOcorrencia+"sede.png",
                                scaledSize: new this.google.maps.Size(30, 30)}
                        })
      this.map.setCenter({lat: parseFloat(this.dadosGps[0].latitude_coop),
                          lng: parseFloat(this.dadosGps[0].longitude_coop)});

      var infowindow = new this.google.maps.InfoWindow({
          content: "Cidade Sede: "+this.dadosCoop.sede
      });
      this.markerSede.addListener("click", () => {
        infowindow.open({
          anchor: this.markerSede,
          map:this.map,
          shouldFocus: false,
        });
      });
    },
    atribuiInfoCoop(dadosGps){
      this.dadosCoop = {};
      this.dadosCoop.coopNome = dadosGps.ge_pessoa.nm_razao+' ['+dadosGps.ge_pessoa.cd_pessoa+']';
      this.dadosCoop.coopCargo =  dadosGps.ds_cargo;
      this.dadosCoop.coopProfissao = dadosGps.nm_profissao;
      this.dadosCoop.idade = dadosGps.idade;
      this.dadosCoop.tempoCnh = dadosGps.tempo_cnh;
      this.dadosCoop.contrato = this.dados.contrato.nome;
      this.dadosCoop.projeto = this.dados.projeto.nome;
      this.dadosCoop.sede = dadosGps.ds_regiao_coop;
      var dt_inicio = this.$tools.converteData(dadosGps.dt_inicio);
      var dt_fim = this.$tools.converteData(dadosGps.dt_final);
      this.dadosCoop.periodo = dt_inicio + ' A ' + dt_fim;
      this.dadosCoop.fotoCoop = "";
      if(dadosGps.nm_caminho_foto){
          this.dadosCoop.fotoCoop = this.$caminhoFotoPerfil + dadosGps.nm_caminho_foto;
      }
    },
    calcularKm(param){
      param.routes[0].legs.forEach((el) => {
        this.kmDiario += el.distance.value
      })
    },
    limparMapa(){
     if(this.directionsAux){
        this.directionsAux.forEach((el) => {
          el.setMap(null);
        })
        this.markerOcorrencias.forEach((el) => {
          el.marker.setMap(null);
        });
        this.directionsAux = [];
        this.markerOcorrencias = [];
      }
    },
    limparFormulario(){
      this.dados.referencia = null;
      this.dados.contrato = null;
      this.dados.matriz = null;
      this.dados.projeto = null;
      this.dados.cooperado = null;
    },
    siglaOcorrencia(sigla){
      switch (sigla) {
        case "E":
          return "Excesso de velocidade";
        case "F":
          return "Uso fora de horário";
        case "M":
          return "Uso na madrugada";
        case "R":
          return "Condução de Risco";
        default:
          return "Informativo";
      }
    }
  },
};
</script>
<style scoped>

.responsive {
  width: 100%;
  height: auto;
}
.div-clickable {
  cursor: pointer;
}
.fundoAcao {
  background-color: gainsboro;
}
.heightCard{
  height: 95%;
}
</style>